import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import { REPORTING_VALUE_DOMAINS } from "web_myplann/Portfolio/Helpers/portfolioReportingDomains";
import { PortfolioRowValueKind } from "web_myplann/Portfolio/Types/portfolioRowValueKind";

const INSURANCE_DOMAINS: ReadonlySet<ClientPortfolioDomainEnum> = new Set([
	ClientPortfolioDomainEnum.LifeInsurance,
	ClientPortfolioDomainEnum.PropertyInsurance,
]);

const LOAN_DOMAINS: ReadonlySet<ClientPortfolioDomainEnum> = new Set([
	ClientPortfolioDomainEnum.BusinessLoans,
	ClientPortfolioDomainEnum.Loans,
	ClientPortfolioDomainEnum.Leasing,
]);

const SERVICE_DOMAINS: ReadonlySet<ClientPortfolioDomainEnum> = new Set([
	ClientPortfolioDomainEnum.Services,
	ClientPortfolioDomainEnum.PaidAdvisory,
]);

export const getPortfolioRowValueKind = (
	domain: ClientPortfolioDomainEnum | null | undefined,
	hasSummary: boolean,
): PortfolioRowValueKind => {
	if (domain === null || domain === undefined) {
		return PortfolioRowValueKind.None;
	}

	if (SERVICE_DOMAINS.has(domain)) {
		return PortfolioRowValueKind.Service;
	}

	const isReportingDomain = REPORTING_VALUE_DOMAINS.includes(domain);

	if (INSURANCE_DOMAINS.has(domain) && !(isReportingDomain && hasSummary)) {
		return PortfolioRowValueKind.InsuranceDates;
	}

	if (LOAN_DOMAINS.has(domain)) {
		return PortfolioRowValueKind.ValueOnly;
	}

	if (isReportingDomain) {
		return PortfolioRowValueKind.ValueWithChange;
	}

	return PortfolioRowValueKind.None;
};
